import { Component, h, Host, Prop, State, Watch } from '@stencil/core';

import { PnStatsInfoDataProps } from './types';

const mockStringArray =
  '[ { "preamble": "Million parcels","formatStyle":"None", "format":"En","startValue":0, "data": 2023, "unit": null, "duration": 0 }, { "preamble": "Million parcels", "format": "En", "startValue":40, "data": 226, "unit": null, "duration": 1000 },{"preamble": "carbon dioxide emissions since 2009", "startValue":0, "format":"En", "formatStyle":"None", "data": -44, "unit": "%", "duration": 2000 }, { "preamble": "Million parcels", "startValue":100, "data": 226, "unit": null, "duration": 1000 }, {"preamble": "carbon dioxide emissions since 2009", "startValue": 30, "data": -44, "unit": "%", "duration": 2000 }, { "preamble": "Million parcels", "startValue": 20, "data": 226, "unit": null, "duration": 1000 }]';

@Component({
  tag: 'pn-stats-info',
  styleUrl: 'pn-stats-info.scss',
})
export class PnStatsInfo {
  @Prop() heading: string = null;
  @Prop() dataArray: string = mockStringArray;
  @Prop() backgroundUrl: string = null;

  @State() myParsedArray: PnStatsInfoDataProps[] = JSON.parse(this.dataArray) as PnStatsInfoDataProps[];

  @Watch('dataArray')
  parseMyArrayProp(newValue: string) {
    if (newValue) this.myParsedArray = JSON.parse(newValue);
  }

  render() {
    return (
      <Host>
        <div class="pn-stats-info__container">
          <div class="pn-stats-info__container__map" style={{ backgroundImage: `url(${this.backgroundUrl})` }}></div>

          <div class="pn-stats-info-image-container">
            <slot name="illustration" />
          </div>

          <div class="pn-stats-info__container__content" style={{ backgroundImage: `url(${this.backgroundUrl})` }}>
            {this.heading && <h3 class="pn-stats-info__container__content__heading">{this.heading}</h3>}
            <div class="pn-stats-info__container__content__data">
              {this.myParsedArray &&
                this.myParsedArray.map((stats, index) => {
                  return (
                    <pn-stats-info-data
                      index={index}
                      startValue={stats.startValue}
                      data={stats.data}
                      unit={stats.unit}
                      preamble={stats.preamble}
                      duration={stats.duration}
                      format={stats.format}
                      formatStyle={stats.formatStyle}
                    ></pn-stats-info-data>
                  );
                })}
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
